import "../../mixins.js"

export default {
  name: 'side-bar',
  components: {},
  props: [],
  data () {
    return {
      isSidebarVisible: false,
      isModalOpen: false,
      requestType: '',
      requestedName: '',
      requestedIsin: '',
      requestedTicker: '',
      requestEmail:'',
      requestMessage:'',
      isRequestSuccessful: false,
    }
  },
  computed: {

  },
  created () {
    this.getInitialSidebarState()
  },
  methods: {
    getInitialSidebarState(){
      let sidebarState = localStorage.getItem('sidebar-visible')
      if(sidebarState == 'true'){
        this.isSidebarVisible = true;
      }else{
        this.isSidebarVisible = false;
      }

    },
    closeSidebar: function(){
      this.isSidebarVisible = false;
      localStorage.setItem('sidebar-visible', this.isSidebarVisible)
    },
    openSidebar: function(){
      this.isSidebarVisible = true;
      localStorage.setItem('sidebar-visible', this.isSidebarVisible)
    },
    openModal: function(){
      this.isModalOpen = true;
    },
    closeModal: function(){
      this.isModalOpen = false;
    },
    sendRequest: async function(){
      var request_data;
      if (this.requestType == "asset_missing")
      {

        request_data = {"name": this.requestedName, "isin" : this.requestedIsin, "ticker" : this.requestedTicker, "email" : this.requestEmail}
        this.putEndpointNoVerify(request_data, 'requestSecurity/');
        setTimeout(() => this.isRequestSuccessful = true, 300)
        this.closeModal();
        setTimeout(() => this.isRequestSuccessful = false, 1500)
      }
      else if (this.requestType == "other")
      {
        
      request_data = {"message": this.requestMessage, "email" : this.requestEmail}
      this.putEndpointNoVerify(request_data, 'contactMessage/');
      setTimeout(() => this.isRequestSuccessful = true, 300)
      this.closeModal();
      setTimeout(() => this.isRequestSuccessful = false, 1500)
      }

    }

  }
}


